import request from '@/utils/request'


// 查询投票排行榜活动管理列表
export function listHuodong(query) {
  return request({
    url: '/zb/huodong/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

export function selectHuodongList(type) {
  return request({
    url: '/zb/huodong/selectHuodongList?type='+type,
    method: 'get'
  })
}

// 查询投票排行榜活动管理分页
export function pageHuodong(query) {
  return request({
    url: '/zb/huodong/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

export function changeStatus (id, status) {
  const data = {
    id,
    status
  }
  return request({
    url: '/zb/huodong/changeStatus',
    method: 'put',
    data: data
  })
}

// 查询投票排行榜活动管理详细
export function getHuodong(data) {
  return request({
    url: '/zb/huodong/detail',
    method: 'get',
    params: data
  })
}

// 新增投票排行榜活动管理
export function addHuodong(data) {
  return request({
    url: '/zb/huodong/add',
    method: 'post',
    data: data
  })
}

// 修改投票排行榜活动管理
export function updateHuodong(data) {
  return request({
    url: '/zb/huodong/edit',
    method: 'post',
    data: data
  })
}

// 删除投票排行榜活动管理
export function delHuodong(data) {
  return request({
    url: '/zb/huodong/delete',
    method: 'post',
    data: data
  })
}
